import React from "react";
import Header from "../../components/Header";
import { goBackToHomeButtton } from "../../components/utils/NotFound";
import { videoData } from "../../data/videos";
import "./style.scss"

const extractVideoId = (url) => {
  const regex = /(?:https?:\/\/(?:www\.)?youtu\.be\/|(?:https?:\/\/(?:www\.)?youtube\.com\/(?:v|e(?:mbed)?)\/))([a-zA-Z0-9_-]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const VideoList = () => {
  return (
    <div className="video-container">
      <h1 className="title">Recommended Videos</h1>
      <div>{goBackToHomeButtton()}</div>
        <div><Header/></div>
      <ul className="video-list">
        {videoData.map((video, index) => {
          const videoId = extractVideoId(video.url);
          const thumbnailUrl = videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : '';
          
          return (
            <li key={index} className="video-item">
              <div className="video-thumbnail">
                {thumbnailUrl && <img src={thumbnailUrl} alt={video.title} />}
              </div>
              <div className="video-content">
                <h2 className="video-title">{video.title}</h2>
                <p className="video-author">{video.author}</p>
                <a
                  href={video.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="video-link"
                >
                  Watch Now
                </a>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default VideoList;
